<template>
<div>
  <Header/>
  <Navigationzj :toptNavi="2"/>
  <div class="hxq_subpage">
    <div>
      <div class="hxq_ppsp">
        <div class="hxq_yzjk_mbx"><a href="/">首页</a> &gt;
        <router-link :to="{path:'/Brand'}">品牌中心</router-link> &gt;
        <a href="javascript:void(0);">{{ brand.title }}</a></div>
        <div class="hxq_ppsp_ppjj">
          <div class="hxq_ppsp_ppjj_lt">
            <img :src="brand.img" width="339" height="179">
          </div>
          <div class="hxq_ppsp_ppjj_rt">
            <div>{{ brand.content }}</div>
            <i>&nbsp;</i>
          </div>
        </div>
        <div class="hxq_fllb_sx">
        <div class="hxq_fllb_sx_yx">
          <div style="min-height:10px"></div>
          <div class="clearfix">
            <el-tag
              v-for="(item,index) in selectName" :key="index"
              closable
              :disable-transitions="false"
              type="danger"
              style="margin-right:10px;"
              @close="handleClose(index)">
              {{item.param_name}}: {{item.name}}
            </el-tag>
          </div>
          <div style="min-height:10px"></div>
        </div>
        </div>
        <div class="hxq_fllb_sx_tj" v-loading="atterloading">
          <div class="hxq_fllb_sx_tj1" v-if="searchCate.length > 0 && searchCateType" :style="fenleiopen?'max-height:200px;overflow-y: auto;margin-top: 10px;':'height:34px;overflow: hidden;margin-top: 10px;'">
            <em>分类：</em>
            <div ref="fenlei" style="width:960px;">
              <template v-for="(item,index) in searchCate">
                <a href="javascript:void(0);" :key="index" @click="checkCate(index)">{{ item.title }}</a>
              </template>
            </div>
            <span v-show="fenleishow" @click="changeOpens()" :data="getHeights('fenlei')">{{fenleiopen?'收起':'展开'}}</span>
          </div>
          <div class="hxq_fllb_sx_tj1" v-if="fourCate && fourCate.length">
            <em>类别：</em>
            <div>
              <!-- <a href="javascript:void(0);" class="on">全部</a> -->
              <template v-for="(item,index) in fourCate">
                <a href="javascript:void(0);" :key="index" @click="checkParam(item)" :class="{on:item.typeLb == true}">{{ item.name }}</a>
              </template>
            </div>
            <!-- <span>更多</span> -->
          </div>
          <div class="hxq_fllb_sx_tj1" v-if="brandList.length && !brandType">
            <em>品牌：</em>
            <div>
              <a href="javascript:void(0);" class="on">全部</a>
              <template v-for="(item,index) in brandList">
                <a href="javascript:void(0);" :key="index" @click="checkBrand(index)">{{ item.name }}</a>
              </template>
            </div>
            <!-- <span>更多</span> -->
          </div>
          <template v-for="(item,index) in Attribute">
            <div class="hxq_fllb_sx_tj1" :key="index" v-if="!item.isSelect" :style="item.open?'height:auto':'height:34px;overflow: hidden;'">
              <em>{{ item.name }}：</em>
              <div :ref="'he'+index">
                <a href="javascript:;" class="on">全部</a>
                <a href="javascript:;" v-for="(value,i) in item.option_values" :key="i" @click="checkAttribute(i,index)">{{ value.name }}</a>
              </div>
              <span v-show="item.showMore" @click="changeOpen(index)" :data="getHeight(('he'+index), index)">{{item.open?'收起':'展开'}}</span>
            </div>
          </template>
        </div>
        <div class="hxq_yzjk_px">
          <div class="hxq_yzjk_px_lt">
            <!-- <a href="javascript:;" style="width: 149px;" paixu="">综合排序</a> -->
            <!-- <a href="javascript:;" style="width: 149px;" pricepx="" paixu="pricepx">价格
            ↑↓
            </a>
            <a  href="javascript:;" style="width: 149px;" xlpx="" paixu="xlpx">销量
            ↓
            </a> -->
          </div>
          <div class="hxq_yzjk_right1">
            <div class="hxq_yzjk_right1_one">
              <span class="pricelass" :class="{on:myprice}" style="width:100px" v-if="current_user && current_user.id && current_user.company_id != 1"><a href="javascript:;"  @click="screen()">协议产品</a></span>
              <span class="bigtut" :class="{on:listMode=='card'}"><a href="javascript:;" @click="listMode='card'">大图</a></span>
              <span class="smalltut" :class="{on:listMode=='list'}"><a href="javascript:;"  @click="listMode='list'">列表</a></span>
            </div>
            <div class="hxq_yzjk_right1_two">
              共 <em class="red">{{ total }}</em> 件商品
              <!-- <em class="red">345435</em> / 56456 -->
            </div>
            <a class="hxq_yzjk_right1_four " href="javascript:;" @click="batchAddCart()">
              加入购物车
            </a>
          </div>
        </div>
        <div class="hxq_ppsp_box" v-if="listMode=='card'" v-loading="qyloading">
          <ul class="hxq_ppsp_ul clearfix">
            <li v-for="(item,index) in list" :key="index" class="this_page_css" style="position:relative;">
              <img class="agreement" src="../../assets/images/xy11.png" v-if="item.pid && current_user.id && current_user.company_id != 1">
              <router-link :to="{path:'/GoodsDetail',query:{id:item.id}}" target="_blank" :title="item.full_title">
                <img v-real-img="item.imgpath" src="../../assets/images/zwtp.jpg" :alt="item.full_title" width="220" height="220">
              </router-link>
              <h3><router-link :to="{path:'/GoodsDetail',query:{id:item.id}}" class="this_page_title" target="_blank" :title="item.full_title">{{ item.full_title }}</router-link></h3>
              <div class="hxq_ppsp_ul_jg">
                <em style="padding:0 7px;">
                  <span v-if="item.tax_price && item.tax_price > 0">￥</span>
                  <span v-if="item.tax_price && item.tax_price > 0" style="font-weight:bold;">{{ item.tax_price }}</span>
                  <span v-else style="font-weight:bold">询价</span>
                  <i style="display: block;width: 67px;height: 25px;background: #fe722c;text-align: center;font-size: 12px;line-height: 25px;color: #fff;border-radius: 4px;float:right;" v-if="item.delivery_time">
                    {{ item.delivery_time }}日出货
                  </i>
                  <i style="display: block;width: 67px;height: 25px;background: #fe722c;text-align: center;font-size: 12px;line-height: 25px;color: #fff;border-radius: 4px;float:right;" v-else>
                    当日出货
                  </i>
                </em>
              </div>
              <div class="hxq_ppsp_ul_join clearfix">
                <div class="hxq_ppsp_ul_join_l" style="height: 40px;padding:0 7px;">
                  <p>订货号：{{ item.sku}}</p>
                  <p>销量：<count-to :start-val="0" :end-val="parseInt(item.sales)" :duration="2600" class="card-panel-num"/></p>
                </div>
              </div>
              <div class="hxq_ppsp_ul_join clearfix">
                <div class="hs-collect" style="height: 32px;line-height: 32px;padding:0 7px;">
                  <el-button v-if="item.isCollect" type="warning" :autofocus="true" size="small" icon="el-icon-star-on" style="float:left;" @click="collect(item)">已收藏</el-button>
                  <el-button v-else type="warning" :autofocus="true" size="small" icon="el-icon-star-off" style="float:left;" @click="collect(item)">收藏</el-button>
                  <el-button type="primary" plain size="small" icon="el-icon-shopping-cart-full" style="float:right;" @click="addCart(item.id)">加入购物车</el-button>
                </div>
              </div>
              <!-- <div class="hxq_ppsp_ul_join clearfix">
                <div style="height: 33px;"></div>
              </div> -->
            </li>
          </ul>
          <div class="cght_cnxhtiwtjsp" v-if="list.length==0">
            <div>
              <em class="myemptydata">暂无数据</em>
              <!-- <router-link :to="{path:'/'}" class="cght_meiyoudingdanscda">去首页看看</router-link> -->
            </div>
          </div>
        </div>
        <div class="hxq_ppsp_box" v-if="listMode=='list'" v-loading="qyloading">
          <div class="fllbsmall_con">
            <div class="fllbsmall_con_tit clearfix">
              <div style="width: 294px;"><span>商品信息</span></div>
              <div style="width: 133px;">品牌</div>
              <div style="width: 342px;">规格</div>
              <div style="width: 139px;">志鹏价</div>
              <div class="w140">预计出货日</div>
              <div class="w145" style="width: 150px;">购买数量</div>
            </div>
            <div class="fllbsmall_con_bottom">
              <ul>
                <li class="clearfix this_page_li"  v-for="(item,index) in list" :key="index">
                  <div class="fllbsmall_con_bottom_1 clearfix" style="width: 294px;">
                    <router-link class="fllbsmall_con_bottom_1l" :to="{path:'/GoodsDetail',query:{id:item.id}}" target="_blank" :title="item.full_title">
                      <img v-real-img="item.imgpath" src="../../assets/images/zwtp.jpg" width="76" height="76">
                    </router-link>
                    <div class="fllbsmall_con_bottom_1r" :class="{'agreement_list':item.pid && current_user.id && current_user.company_id != 1}">
                      <h3><router-link :to="{path:'/GoodsDetail',query:{id:item.id}}" target="_blank" :title="item.full_title">{{ item.full_title }}</router-link></h3>
                      <span>订货号：{{ item.sku }}</span>
                    </div>
                  </div>
                  <div class="m33" style="width: 133px;">{{item.brand_title}}</div>
                  <div style="width: 342px;text-align:left;height:80px">
                    <el-tag size="mini" style="margin-left:10px;margin-top:6px;" v-for="(sp,index) in item.specParamList" :key="index">{{sp.param_name}}：{{sp.option_value}}</el-tag>
                  </div>
                  <div class="m33 red" style="width: 139px;font-weight:bold;" v-if="item.tax_price && item.tax_price > 0">￥{{ item.tax_price}}</div>
                  <div class="m33 red" style="width: 139px;font-weight:bold;" v-else>询价</div>
                  <!--<div class="w133 red m33">￥{$vo.marketprice}</div>-->
                  <div class="w140 list_surekc" style="margin-top:18px;">
                    <em v-if="item.delivery_time">
                      <span>{{ item.delivery_time }}日出货</span>
                    </em>
                    <em v-else>
                      <em>有库存</em>
                      <span>当日出货</span>
                    </em>
                  </div>
                  <div class="list_sureinput" style="margin-top:16px;width:130px;">
                    <el-input-number v-model="item.number" :min="item.limits" size="small"></el-input-number>
                    <div class="list_sureinput_b">
                      {{ item.units }}
                    </div>
                  </div>
                </li>
              </ul>
              <div class="cght_cnxhtiwtjsp" v-if="list.length==0">
                <div>
                  <em class="myemptydata">暂无数据</em>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="LoadData" />
  </div>
<Footer/>
</div>
</template>
<script>
import api from '@/api/goods'
import bra from '@/api/brand'
import cate from '@/api/createGroy'
import vuelist from '@/utils/vue_list'
import Pagination from '@/components/Pagination'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Navigationzj from '@/components/Navigationzj'
import CountTo from 'vue-count-to'
import { mapGetters } from 'vuex'

export default {
  name: 'Ppxq',
  mixins: [vuelist],
  components: { Pagination, Header, Footer, Navigationzj, CountTo },
  data () {
    return {
      api,
      bid: this.$route.query.bid,
      brand: [],
      listMode: 'card',
      list: [],
      searchCate: [],
      fourCate: [],
      Attribute: [],
      brandList: [],
      brandType: false,
      searchCateType: true,
      qyloading: false,
      atterloading: false,
      selectName: [],
      selectBrand: [],
      group_id: '',
      myprice: false,
      fenleishow: false,
      fenleiopen: false
    }
  },
  computed: {
    ...mapGetters(['current_user'])
  },
  mounted () {
    this.getBrand()
    this.listQuery.brand_id = this.bid
    this.LoadData()
  },
  methods: {
    screen () {
      this.myprice = !this.myprice
      this.listQuery.page = 1
      this.listQuery.myprice = this.myprice
      this.LoadData()
    },
    afterLoadData (list) {
      list.forEach(res => {
        if (res.specParamList) { res.specParamList = JSON.parse(res.specParamList) }
      })
      return list
    },
    changeOpen (index) {
      this.$set(this.Attribute[index], 'open', !this.Attribute[index].open)
    },
    changeOpens () {
      if (this.fenleiopen) {
        this.fenleiopen = false
      } else {
        this.fenleiopen = true
      }
    },
    getHeight (name, index) {
      this.$nextTick(() => {
        if (this.$refs[name][0]['offsetHeight'] > 34) {
          this.Attribute[index].showMore = true
        }
      })
    },
    getHeights (name) {
      this.$nextTick(() => {
        if (this.$refs[name]['offsetHeight'] > 34) {
          this.fenleishow = true
        }
      })
    },
    getBrand () {
      bra.getBrand({bid: this.bid}).then(res => {
        this.brand = res.items
        this.brandCategpry(res.items.id)
      })
    },
    brandCategpry (bid) {
      bra.brandCategpry({bid: bid}).then(res => {
        this.searchCate = res.items
      })
    },
    checkBrand (index) {
      this.brandType = true
      this.selectBrand = this.brandList[index] // 此处赋值只为点击品牌传值，减少后台处理
      this.selectName.push(this.brandList[index])
      this.listQuery.brand_id = this.brandList[index].id
      this.attrFiltrate()
      // console.info(this.selectBrand)
    },
    // 分类点击筛选
    checkCate (index) {
      this.cid = this.searchCate[index].id
      bra.getGroupList({cid: this.cid}).then(res => {
        if (res.items.length === 1) {
          this.searchCateType = false
          this.getAttribute(res.items[0].id)
          // this.listQuery.group_id = res.items[0].id
        } else {
          let fourCateList = res.items
          fourCateList.forEach(res => { res.typeLb = false })
          this.fourCate = fourCateList
          this.searchCateType = false
        }
      })
      this.listQuery.category_id = this.cid
      this.LoadData()
      var cateList = {
        param_name: '分类',
        name: this.searchCate[index].title,
        id: this.searchCate[index].id,
        cate: 'cate' // 用于判断当前取消的是不是分类
      }
      this.selectName.push(cateList)
    },
    getAttribute (groupId) {
      var byValue = {}
      if (groupId) {
        byValue = {
          cid: this.cid,
          groupId: groupId,
          brand_id: this.bid
        }
      } else {
        byValue = {
          cid: this.cid,
          brand_id: this.bid
        }
      }
      this.atterloading = true
      cate.getAttribute(byValue).then(res => {
        let list = res.items
        let brandList = res.brandList
        list.forEach(ele => { ele.showMore = false; ele.open = false; ele.isSelect = false })
        brandList.forEach(ele => { ele.showMore = false; ele.open = false; ele.isSelect = false; ele.param_name = '品牌' })
        this.Attribute = list
        this.brandList = brandList
        this.atterloading = false
      })
    },
    // 属性筛选
    checkAttribute (i, index) {
      if (this.selectName.indexOf(this.Attribute[index]['option_values'][i]) === -1) {
        this.$set(this.Attribute[index], 'isSelect', true)
        this.selectName.push(this.Attribute[index]['option_values'][i])
      }
      this.attrFiltrate()
    },
    // 取消选择的属性
    handleClose (index) {
      this.Attribute.forEach((res, i) => {
        if (res.id === this.selectName[index].param_id) {
          this.$set(this.Attribute[i], 'isSelect', false)
        }
      })
      // 判断当前取消的是不是品牌
      if (this.selectName[index].code) {
        this.brandType = false
        this.selectBrand = []
      }
      // 判断当前取消的是不是分类
      if (this.selectName[index].cate) {
        this.selectName = []
        this.getBrand()
        this.listQuery.page = 1
        // this.listQuery.brand_id = ''
        this.listQuery.category_id = ''
        this.listQuery.goods_list_id = ''
        this.LoadData()
        this.searchCateType = true
        this.Attribute = []
        this.brandList = []
      } else {
        // 因为取消分类选项不需要请求属性。所以放到else里
        this.selectName.splice(index, 1)
        this.attrFiltrate()
      }
    },
    attrFiltrate () {
      var newSelectName = Object.assign([], this.selectName)
      newSelectName.forEach((res, index) => {
        // 判断当前点击是否是品牌，是的话不加入newSelectName这个对象中
        if (res.code) {
          newSelectName.splice(index, 1)
        }
        // 判断当前点击是否是分类，是的话不加入newSelectName这个对象中
        if (res.cate) {
          newSelectName.splice(index, 1)
        }
      })
      this.selectBrand = {'id': this.bid} // 因为这是品牌详情页面，所以此页面独有，查询属性时传值当前品牌ID
      this.atterloading = true
      api.attrFiltrate({attrrButeList: JSON.stringify(newSelectName), category_id: this.cid, brand: JSON.stringify(this.selectBrand)}).then(response => {
        let list = response.items
        let brandList = response.brand_list
        list.forEach(ele => {
          ele.showMore = false; ele.open = false; ele.isSelect = false
          this.selectName.forEach(res => {
            if (ele.id === res.param_id) {
              ele.isSelect = true
            }
          })
        })
        brandList.forEach(ele => { ele.showMore = false; ele.open = false; ele.isSelect = false; ele.param_name = '品牌' })
        this.Attribute = list
        this.brandList = brandList
        this.atterloading = false
        this.listQuery.page = 1
        this.listQuery.goods_list_id = response.goods_id
        this.LoadData()
      })
    },
    // 收藏
    collect (item) {
      if (!this.current_user || !this.current_user.id) {
        this.$message.error('请先登录')
        return
      }
      api.delOrAddCollect({'member_id': this.current_user.id, 'goods_id': item.id}).then(res => {
        item.isCollect = item.isCollect === 1 ? 0 : 1
      })
    },
    addCart (id) {
      if (!this.current_user.id) {
        this.$message.error('请先登录')
        return
      }
      api.addCart({
        'id': id
      }).then(response => {
        this.$notify({
          title: '加入购物车',
          message: '添加成功',
          type: 'success'
        })
      })
    },
    checkParam (item) {
      this.getAttribute(item.id)
      // this.listQuery.group_id = item.id
      this.listQuery.page = 1
      this.fourCate.forEach(res => { res.typeLb = false })
      item.typeLb = true
      this.selectName = []
      this.listQuery.goods_list_id = ''
      this.LoadData()
    },
    batchAddCart () {
      if (!this.current_user.id) {
        this.$message.error('请先登录')
        return false
      }
      var subCartList = []
      this.list.map((res, index) => {
        if (res.number) {
          var cartList = {
            goods_id: res.id,
            number: res.number
          }
          subCartList.push(cartList)
        }
      })
      if (subCartList.length > 0) {
        api.batchAddCart(subCartList).then(res => {
          this.$message({
            message: '添加成功',
            type: 'success'
          })
        })
      }
    }
  }
}
</script>
<style scoped>
.agreement{
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 12;
  width: 60px;
}
.this_page_title{
  padding: 0 7px 0 7px;
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:2;
}
.agreement_list{
  background-image:url('../../assets/images/xy22.png');
  background-repeat: no-repeat;
  background-position: right top;
  background-size: 70px 70px;
}
.this_page_css {
  border-radius:5px ;
  margin: 15px 15px 0 0;
  padding: 10px 3px 10px 3px;
  -webkit-transition: all 0.25s ease-out;
  -o-transition: all 0.25s ease-out;
  transition: all 0.25s ease-out;
  border:1px solid #eaeaea;
}
.this_page_css:hover {
  box-shadow: 0 0 5px #cbdaf5;
  -webkit-box-shadow: 0 0 5px #cbdaf5;
  -moz-box-shadow: 0 0 5px #cbdaf5;
  transform: translate(0, -10px);
}
.this_page_li {
  margin: 15px 0;
  -webkit-transition: all 0.25s ease-out;
  -o-transition: all 0.25s ease-out;
  transition: all 0.25s ease-out;
}
.this_page_li:hover {
  box-shadow: 0 0 5px #cbdaf5;
  -webkit-box-shadow: 0 0 5px #cbdaf5;
  -moz-box-shadow: 0 0 5px #cbdaf5;
  transform: translate(0, -10px);
}
.fllbsmall_con_bottom_1l img {
  border: none;
}
.fllbsmall_con_bottom li{
  border: none;
  padding: 5px 0;
}
.cght_cnxhtiwtjsp{ height:167px; width:100%; padding-top:175px;}
.cght_cnxhtiwtjsp div{ width:144px; text-align:center; padding-left:100px; background:url(../../assets/images/spsc_img02.png) no-repeat left center; height:60px; line-height:60px;font-size:18px; color:#959595; margin:0px auto; clear:both;}
.myemptydata {color:#959595}
</style>



// WEBPACK FOOTER //
// src/view/brand/ppxq.vue